import { get as networkGet } from '../../networkClient';
import { Path } from '../path';

export async function getPromotions(clientId) {
  try {
    const response = await networkGet(
      Path.GET_PROMOTIONS,
      { client_id: clientId },
      null,
      true,
      true
    );

    return response?.data;
  } catch (error) {
    return {
      error: true,
      message: error.message,
      status: error.response?.status
    };
  }
}
